import React from 'react';
import InputMask from 'react-input-mask';

import iconPasswordView from '../../../../../assets/images/icone_view.svg';
import iconPasswordHide from '../../../../../assets/images/icone_esconder.svg';

export default (props) => {
  const {
    id,
    type,
    label,
    placeholder,
    value,
    onChange,
    toggleShowPassword,
    showPassword,
    disabled,
    mask,
  } = props;

  return (
    <div className="form-group">
      <label className="form-group__label" htmlFor={id}>
        {label}
      </label>
      <InputMask
        id={id}
        disabled={disabled}
        name={id}
        mask={mask}
        type={type}
        className="form-control"
        maskChar=" "
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {toggleShowPassword && (
        <button
          className="channel-whatsapp-show-password-button"
          onClick={toggleShowPassword}
          type="button"
        >
          <img
            src={showPassword ? iconPasswordHide : iconPasswordView}
            alt=""
          />
        </button>
      )}
    </div>
  );
};
